import React from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

// DSN is a publishable value, safe to keep in the client bundle.
const dsn =
  (import.meta.env.VITE_SENTRY_DSN as string | undefined) ||
  "https://b75ef2284d21a42d3b55c46ac8572ab5@o4511891843710976.ingest.us.sentry.io/4511891851444224";

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/splitpot\.lovable\.app/],
  });
}
